import React from "react";
import { INSIGHTS } from "@/data/insights";
import { Overline } from "@/components/brand/SectionDivider";
import { ConcentricMonogram } from "@/components/brand/ConcentricMonogram";
import { AmbientLight } from "@/components/brand/AmbientLight";
import useDocumentTitle from "@/lib/useDocumentTitle";

export default function ResourceCenter() {
  useDocumentTitle("Resource Center | AG Public Adjusting");
  return (
    <main data-testid="resource-center-page" className="pt-32 bg-midnight-gradient">
      <section className="relative py-24 lg:py-36 overflow-hidden">
        <AmbientLight size={1100} color="blue" intensity={0.45} style={{ top: "-5%", left: "20%" }} />
        <div className="hidden lg:block absolute right-12 top-1/2 -translate-y-1/2 opacity-30 pointer-events-none" aria-hidden>
          <ConcentricMonogram size={500} variant="ghost" glowColor="blue" />
        </div>
        <div className="relative max-w-[1440px] mx-auto px-6 lg:px-12">
          <Overline className="mb-8">Policyholder Resource Center</Overline>
          <h1 className="font-display-tight text-white text-[clamp(2.8rem,6vw,6rem)] leading-[0.95] tracking-[-0.045em] max-w-4xl">
            Educational authority,
            <br />
            <span className="gold-metallic font-display font-light">for the policyholder.</span>
          </h1>
          <p className="mt-12 text-ag-text-secondary text-lg leading-[1.65] font-light max-w-2xl">
            Practical guides, statutory references, and documentation protocols. Written to inform —
            not to promote.
          </p>
        </div>
      </section>

      <section className="py-20 lg:py-28 border-t border-white/5">
        <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 gap-4">
            {INSIGHTS.map((a) => (
              <article
                key={a.slug}
                data-testid={`resource-${a.slug}`}
                className="glass p-10 lg:p-14 transition-all duration-500 group cursor-pointer hover:border-gold/30"
              >
                <Overline className="mb-5">{a.category}</Overline>
                <h2 className="font-display-tight text-white text-[clamp(1.75rem,3vw,2.5rem)] group-hover:gold-metallic group-hover:text-transparent transition-colors leading-[1.1] mb-5 font-light tracking-[-0.035em]">
                  {a.title}
                </h2>
                <p className="text-ag-text-secondary leading-[1.65] font-light max-w-xl">{a.excerpt}</p>
                <div className="mt-6 font-mono text-[0.62rem] text-ag-text-muted tracking-[0.28em] uppercase">{a.read_time}</div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
